import { useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Divider, TextField, CardActions  } from "@mui/material";
import { useData } from "../../../context/DataContext";
import { updateSoilReport } from "../../../context/createAPI"
import { useNavigate, useLocation } from 'react-router-dom';
import SingleSelect from "../../../components/Selections/singleSelect";
import CustomButton from "../../../components/buttons/customButton";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SnackbarMessage from "../../../components/snackBar/snackBar";


function SoilReportEdit() {
    const navigate = useNavigate();
    const location = useLocation();
    const { rowData, stateData } = location.state || {};
    const { years = [], soilTypes = [], cropTypes = [], villageGroups = [], farmers = [], user = {}, handleSoilReports } = useData();
    const yearIndex = years[0]?.value;
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const [state, setState] = useState({
        selectedVillageValue: "",
        selectedGroupValue: "",
        selectedFarmerValue: "",
        selectedSoilTypeId: "",
        selectedCorpsTypeId: "",
        selectedFarmerOrVillageType: "1",
        surveyNumber: "",
        phValue: "",
        ecValue: "",
        ocValue: "",
        nValue: "",
        kValue: "",
        pValue: "",
        clayContent: "",
        cecValue: "",
        target_year: yearIndex,
        farmersEnable: true,
        loading: false,
        submitMessage: "",
        selectedLevelOption: 1,
        groupsArray: [],
        villagesArray: [],
        farmersArray: []
    });
    console.log("state", +state.selectedFarmerValue);

    const [errors, setErrors] = useState({});

    const handleFarmers = (name, value) => {
        let farmersData = []
        if (user.level_id === 1 && name === "selectedVillageValue") {
            farmersData = farmers.filter((item) => parseInt(item.village_id) === parseInt(value)).map((a) => ({ value: a.id, label: a.farmer_name }))
        } else if (user.level_id === 2 && name === "selectedGroupValue") {
            farmersData = farmers.filter((item) => parseInt(item.ff_group_id) === parseInt(value)).map((a) => ({ value: a.id, label: a.farmer_name }))
        }

        setState((prev) => ({
            ...prev,
            farmersArray: farmersData,
        }))
    }

    const handleInputChange = (name, value) => {

        if (name === "selectedVillageValue" || name === "selectedGroupValue") {
            handleFarmers(name, value)
        }
        const regex = /^\d{0,5}(\.\d{0,2})?$/;
        const decimalFields = [
            "phValue",
            "ecValue",
            "ocValue",
            "nValue",
            "pValue",
            "kValue",
            "clayContent",
            "cecValue"
        ];
        const decimalFields1 = ["surveyNumber"];
        const regex1 = /^[a-zA-Z0-9\/\\-]+$/;
        if (decimalFields.includes(name)) {
            if (regex.test(value) || value === "") {
                setState((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        } else if (decimalFields1.includes(name)) {
            if (regex1.test(value) || value === "") {
                setState((prev) => ({
                    ...prev,
                    [name]: value,
                }));
            }
        }
        else {
            setState((prev) => ({
                ...prev,
                [name]: value,
                farmersEnable: Object.keys(rowData).length > 0
            }));
        }


        if (name === "selectedFarmerOrVillageType") {

            setState((prev) => ({
                ...prev,
                selectedVillageValue: "",
                selectedGroupValue: "",
                selectedFarmerValue: "",
                selectedSoilTypeId: "",
                selectedCorpsTypeId: "",
                surveyNumber: "",
                phValue: "",
                ecValue: "",
                ocValue: "",
                nValue: "",
                kValue: "",
                pValue: "",
                clayContent: "",
                cecValue: "",
                target_year: yearIndex,
                farmersEnable: true,
                loading: false,
                farmersArray: []

            }))
            setErrors({});
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [`${name}Error`]: "",
        }));
    };

    useEffect(() => {
        let villageData = [];
        let groupData = [];
        if (villageGroups && villageGroups.length > 0) {
            const villageGroupData = villageGroups[3].data;
            const villageFiletrData = villageGroupData.filter((item) => item.village_id !== "")
            const groupFilterData = villageGroupData.filter((item) => item.group_id !== "")


            if (user.level_id === 1) {
                villageData = villageFiletrData.map(village => ({
                    value: village.village_id,
                    label: village.village
                }))
            } else if (user.level_id === 2) {
                groupData = groupFilterData.map(group => ({
                    value: group.group_id,
                    label: group.Groups
                }))
            } else {

                villageData = villageFiletrData.map(village => ({
                    value: village.village_id,
                    label: village.village
                }))
                groupData = groupFilterData.map(group => ({
                    value: group.group_id,
                    label: group.Groups
                }))
            }
            setState((prevState) => ({
                ...prevState,
                groupsArray: groupData,
                villagesArray: villageData
            }));

        }

        //prepolate
        if (Object.keys(rowData).length > 0) {
            let farmersData = []
            if (user.level_id === 1 && rowData.village_id) {
                handleFarmers("selectedVillageValue", rowData.village_id);
            } else if (user.level_id === 2 && rowData.ff_group_id) {
                handleFarmers("selectedGroupValue", rowData.ff_group_id);
            } else {
                farmersData = farmers.map((item) => ({ value: item.id, label: item.farmer_name }))
            }

            setState((prevState) => ({
                ...prevState,
                selectedVillageValue: rowData.village_id ? rowData.village_id.toString() : "",
                selectedGroupValue: rowData.ff_group_id ? rowData.ff_group_id.toString() : "",
                selectedFarmerValue: rowData.farmer_id ? rowData.farmer_id.toString() : "",
                selectedSoilTypeId: rowData.soil_type_id,
                selectedCorpsTypeId: rowData.crop_type_id,
                surveyNumber: rowData.survey_no,
                phValue: rowData.ph,
                ecValue: rowData.ec,
                ocValue: rowData.oc,
                nValue: rowData.n,
                kValue: rowData.k,
                pValue: rowData.p,
                clayContent: rowData.clay_content,
                cecValue: rowData.cec,
                target_year: yearIndex,
                farmersEnable: true,
                groupsArray: groupData,
                villagesArray: villageData,
                farmersArray: farmersData
            }));
            if (user.level_id === 1 && rowData.village_id) {
                handleFarmers("selectedVillageValue", rowData.village_id);
            } else if (user.level_id === 2 && rowData.ff_group_id) {
                handleFarmers("selectedGroupValue", rowData.ff_group_id);
            } else {

            }

        } else {
            setState((prevState) => ({
                ...prevState,
                selectedVillageValue: "",
                selectedGroupValue: "",
                selectedFarmerValue: "",
                selectedSoilTypeId: "",
                selectedCorpsTypeId: "",
                surveyNumber: "",
                phValue: "",
                ecValue: "",
                ocValue: "",
                nValue: "",
                kValue: "",
                pValue: "",
                clayContent: "",
                cecValue: "",
                target_year: yearIndex,
                groupsArray: [],
                villagesArray: []
            }));
        }

    }, [villageGroups, farmers, user.level_id, user.user_level_id, rowData]);


    const validateFields = () => {

        const validations = [
            { field: "selectedSoilTypeId", error: "Select Soil Type" },
            { field: "selectedCorpsTypeId", error: "Select Crops Type" },
            { field: "selectedGroupValue", error: "Select Group" },
            { field: "selectedVillageValue", error: "Select Village" },
            ...(stateData.selectedVillageWiseOption !== 1 ? [{ field: "selectedFarmerValue", error: "Select Farmer" }] : []),
            { field: "surveyNumber", error: "Enter Survey Number" },
            { field: "phValue", error: "Enter pH Value" },
            { field: "ecValue", error: "Enter EC Value" },
            { field: "ocValue", error: "Enter OC Value" },
            { field: "nValue", error: "Enter N Value" },
            { field: "pValue", error: "Enter P Value" },
            { field: "kValue", error: "Enter K Value" },
            { field: "clayContent", error: "Enter Clay Content" },
            { field: "cecValue", error: "Enter CEC Value" },
        ];

        const newErrors = validations.reduce((acc, validation) => {

            // Skip validation for selectedVillageValue if level_id is 1
            if (validation.field === "selectedVillageValue" && user?.level_id !== 1) {
                return acc; // Skip error for villages if user level is 1
            }
            // Skip validation for selectedGroupValue if level_id is 2
            if (validation.field === "selectedGroupValue" && user?.level_id !== 2) {
                return acc; // Skip error for groups if user level is 2
            }
            if (!state[validation.field]) {
                acc[`${validation.field}Error`] = validation.error;
            }
            return acc;
        }, {});

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleUpdateSoilReport = async (e) => {
        e.preventDefault();
        if (!validateFields()) {
            return;
        }

        setState((prevState) => ({
            ...prevState,
            loading: true
        }));

        try {
            const updateSoilApi = await updateSoilReport({
                id: rowData.id,
                soil_type_id: state.selectedSoilTypeId,
                survey_no: state.surveyNumber,
                crop_type_id: state.selectedCorpsTypeId,
                ph: state.phValue,
                ec: state.ecValue,
                oc: state.ocValue,
                n: state.nValue,
                p: state.pValue,
                k: state.kValue,
                clay_content: state.clayContent,
                recommendations: {},
                cec: state.cecValue,
                updated_by: user.user_id
            });

            if (updateSoilApi.statusCode === 200) {
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    submitMessage: updateSoilApi.data
                }));
                setTimeout(() => {
                    handleSoilReports()
                    navigate(-1)
                }, 2000);


                setSnackbar({
                    open: true,
                    message: updateSoilApi.data || "Soil Report Submitted Successfully..",
                    severity: "success",
                });

            } else {
                setState((prevState) => ({
                    ...prevState,
                    loading: false,
                    submitMessage: "Submission failed. Please try again."
                }));
            }
        } catch (error) {
            console.error("Error creating soil report:", error);
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    };

    return (
        <Box>

            <Card elevation={6}>

                <Box
                    display="flex"
                    alignItems="center"
                    p={1}
                >
                    <CustomButton
                        label="Back"
                        status={false}
                        onClick={() => navigate(-1)}
                        icon={<ArrowBackIcon />}
                    />

                    {/* <Typography
                        variant="body1"
                        sx={{
                            flex: 1,
                            textAlign: "center",
                            fontWeight: 600,
                            textTransform: "uppercase"
                        }}
                    >
                        Edit SoilReport
                    </Typography> */}
                </Box>

                <Divider sx={{ my: 0,  bgcolor: '#f5f1f1ff' }} />

                <CardContent>
                    <Grid container spacing={1}>
                        {
                            [
                                ...stateData.selectedLevelType === 2 ? [{ id: 1, name: "selectedGroupValue", label: "Select Group", value: state.selectedGroupValue, options: state.groupsArray, error: errors.selectedGroupValueError, type: "select", disabled: true }] :
                                    [{ id: 2, name: "selectedVillageValue", label: "Select Village", value: state.selectedVillageValue, options: state.villagesArray, error: errors.selectedVillageValueError, type: "select", disabled: true }],
                                ...stateData.selectedVillageWiseOption === 2 || stateData.selectedLevelType === 2 ? [{ id: 3, name: "selectedFarmerValue", label: "Select Farmer", value: +state.selectedFarmerValue, options: state.farmersArray, error: errors.selectedFarmerValueError, disabled: state.farmersEnable, type: "select" }] : [],
                                { id: 4, name: "selectedSoilTypeId", label: "Soil Types", value: state.selectedSoilTypeId, options: soilTypes, error: errors.selectedSoilTypeIdError, type: "select" },
                                { id: 5, name: "selectedCorpsTypeId", label: "Crops Types", value: state.selectedCorpsTypeId, options: cropTypes, error: errors.selectedCorpsTypeIdError, type: "select" },
                                { id: 6, name: "surveyNumber", label: "Survey Number", value: state.surveyNumber, error: errors.surveyNumberError, type: "text", limit: 5 },
                                { id: 7, name: "phValue", label: "PH Value", value: state.phValue, error: errors.phValueError, type: "text", limit: 5 },
                                { id: 8, name: "ecValue", label: "EC Value", value: state.ecValue, error: errors.ecValueError, type: "text", limit: 5 },
                                { id: 9, name: "ocValue", label: "OC Value", value: state.ocValue, error: errors.ocValueError, type: "text", limit: 5 },
                                { id: 10, name: "nValue", label: "N Value", value: state.nValue, error: errors.nValueError, type: "text", limit: 5 },
                                { id: 11, name: "pValue", label: "P Value", value: state.pValue, error: errors.pValueError, type: "text", limit: 5 },
                                { id: 12, name: "kValue", label: "K Value", value: state.kValue, error: errors.kValueError, type: "text", limit: 5 },
                                { id: 13, name: "clayContent", label: "Clay Content", value: state.clayContent, error: errors.clayContentError, type: "text", limit: 5 },
                                { id: 14, name: "cecValue", label: "CEC", value: state.cecValue, error: errors.cecValueError, type: "text", limit: 5 },
                                { id: 15, label: "Select Year", name: "target_year", value: years[0]?.value ?? state.target_year, options: [years[0]], disabled: true, type: "select" }
                            ].map((field, index) => (
                                <Grid item size={{ xs: 12, md: 4 }} mt={1}>
                                    {
                                        field.type === "select" ? (
                                            <SingleSelect
                                                name={field.name}
                                                label={field.label}
                                                options={field.options || []}
                                                value={field.value}
                                                disabled={field.disabled}
                                                onChange={handleInputChange}
                                                error={field.error}
                                                formHelperText={true}
                                            />
                                        ) : (
                                            <TextField
                                                fullWidth
                                                size="small"
                                                name={field.name}
                                                type={field.type}
                                                label={field.label}
                                                placeholder={field.label}
                                                value={field.value}
                                                onChange={(e) => handleInputChange(field.name, e.target.value)}
                                                inputProps={{ maxLength: field.limit }}
                                                error={!!field.error}
                                                helperText={
                                                    field.error ||
                                                    (field.limit
                                                        ? `${(state[field.name] || "").length}/${field.limit}`
                                                        : "")
                                                }
                                            />
                                        )
                                    }
                                </Grid>
                            ))
                        }
                    </Grid>
                </CardContent>

                <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                    <CustomButton
                        status={state.loading === true ? "loading" : "idle"}
                        onClick={handleUpdateSoilReport}
                        label="Update Report"
                        loadingLabel="Submitting.."
                    />
                </CardActions>
            </Card>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    );
}

export default SoilReportEdit;
